import { render, staticRenderFns } from "./MoneyBoxEdit.vue?vue&type=template&id=b264d940"
import script from "./MoneyBoxEdit.vue?vue&type=script&lang=js"
export * from "./MoneyBoxEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports